"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ReloadOnWake_1 = require("./ReloadOnWake");
var react_1 = __importDefault(require("react"));
var Discover_1 = __importDefault(require("Discover/Discover"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var Axios_1 = require("@CommonFrontend/Utils/Axios");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
module.exports = function (di, invoke, $rootScope, $state, make, account, user, appViewState, scopeUi, loadFonts, styleWorker, notReadyForMobile, domFrame, userHistory, telemetry, usingFeature) {
    var _a;
    window["$"] = $;
    scopeUi.viewState = appViewState;
    scopeUi.domFrame = domFrame;
    scopeUi.notReadyForMobile = notReadyForMobile;
    appViewState.initialDataLoaded = true;
    scopeUi.appViewState = appViewState;
    if (scopeUi.randomTips != null) {
        scopeUi.randomTips.clearRotatingTip();
    }
    var objectFit = require("object-fit/dist/polyfill.object-fit.min.js");
    objectFit.polyfill({
        selector: "video",
        fittype: "cover",
        disableCrossDomain: "true",
    });
    $rootScope.di = di;
    $rootScope.appViewState = appViewState;
    make(require("Common/Telemetry/TimeInAppTracker"), {
        trackEvent: function (event) { return telemetry.trackOnly(event); },
    });
    make(require("./Persister"));
    invoke(require("Utils/FormFactorMonitor"));
    invoke(require("./IdentifyUser"));
    (0, Axios_1.initRetry)();
    invoke(require("./UnauthorisedNotifier").default);
    var loadPreTCDCStyles = account.styleVersion !== 2 && !usingFeature(FeatureFlag_1.default.AllowBlockMigration);
    if (loadPreTCDCStyles) {
        if ((_a = account.renderedStyleSheet) === null || _a === void 0 ? void 0 : _a.length) {
            styleWorker.addToHead(account.renderedStyleSheet, "qwilr-style-banks");
        }
        else {
            styleWorker.addStyles();
        }
    }
    loadFonts();
    scopeUi.discover = di.get("mountReactComponent")(react_1.default.createElement(Discover_1.default));
    invoke(require("./LogDetails"));
    invoke(require("./UserNavigation").default);
    $rootScope.$on("$locationChangeSuccess", function () { return invoke(require("./TrialComplete")); });
    (0, ReloadOnWake_1.reloadOnWake)(telemetry, account, user);
    scopeUi.bodyClassName = tokens_1.lightTheme;
};
